import Vue from 'vue'

export default Vue.extend({
	mounted(): void {
		document.addEventListener('keydown', this.keydownHandler)
		this.$once('hook:destroyed', () => {
			document.removeEventListener('keydown', this.keydownHandler)
		})
	},
	methods: {
		keydownHandler(e: KeyboardEvent): void {
			if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
				;(this as any).onEscapePress()
			}
		}
	}
})
